<template>
  <dv-border-box-11 :title="param.elecName" class="box">
    <div class="box-number">{{ num + 1 }}</div>
    <div class="box-content">
      <div class="box-content-top">
        <div class="box-content-top-item">
          <div class="box-content-top-item-label">充电枪数量：</div>
          <dv-border-box-10 class="box-content-top-item-num">
            <!-- <number-grow :value="param.elecNums" :time="2"></number-grow
          > -->
            {{ param.elecNums }}
          </dv-border-box-10>
        </div>
        <div class="box-content-top-item">
          <div class="box-content-top-item-label">在线数量：</div>
          <dv-border-box-10 class="box-content-top-item-num">
            <!-- <number-grow :value="param.onlineNums" :time="2"></number-grow
          > -->
            {{ param.onlineNums }}
          </dv-border-box-10>
        </div>
        <div class="box-content-top-item">
          <div class="box-content-top-item-label">设备总功率：</div>
          <dv-border-box-10 class="box-content-top-item-num">
            <!-- <number-grow :value="param.elecPow" :time="2"></number-grow
          > -->
            {{ param.elecPow }}
          </dv-border-box-10>
        </div>
        <div class="box-content-top-item">
          <div class="box-content-top-item-label">在充数量：</div>
          <dv-border-box-10 class="box-content-top-item-num">
            <!-- <number-grow :value="param.elecOnline" :time="2"></number-grow
          > -->
            {{ param.elecOnline }}
          </dv-border-box-10>
        </div>
      </div>
      <div class="box-content-bottom">
        <div class="box-content-bottom-item">
          <div class="box-content-bottom-item-label">最新故障：</div>
          <div class="box-content-bottom-item-val">
            {{ param.newErrorName }}
          </div>
        </div>
        <div class="box-content-bottom-item">
          <div class="box-content-bottom-item-label">故障率：</div>
          <div class="box-content-bottom-item-val">
            <dv-percent-pond
              :config="{ value: param.failureRate }"
              style="width: 200px; height: 34px"
            />
          </div>
        </div>
        <div class="box-content-bottom-item">
          <div class="box-content-bottom-item-label">地址：</div>
          <div class="box-content-bottom-item-val">{{ param.elecAdd }}</div>
        </div>
        <div class="box-content-bottom-item">
          <div class="box-content-bottom-item-label">更新日期：</div>
          <div class="box-content-bottom-item-val">
            {{ param.newCheckDate | timeFormatter }}
          </div>
        </div>
      </div>
    </div>
  </dv-border-box-11>
</template>

<script>
// import NumberGrow from "./NumberGrow.vue";
export default {
  name: "ViewItem",
  components: {
    // NumberGrow,
  },
  filters: {
    timeFormatter(timestamp) {
      function addZero(m) {
        return m < 10 ? "0" + m : m;
      }
      if (timestamp) {
        var time = new Date(timestamp);
        var y = time.getFullYear();
        var M = time.getMonth() + 1;
        var d = time.getDate();
        var h = time.getHours();
        var m = time.getMinutes();
        var s = time.getSeconds();
        return (
          y +
          "-" +
          addZero(M) +
          "-" +
          addZero(d) +
          " " +
          addZero(h) +
          ":" +
          addZero(m) +
          ":" +
          addZero(s)
        );
      } else {
        return "暂无数据";
      }
    },
  },
  props: {
    param: {
      type: Object,
    },
    num: {
      Number,
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  margin: 20px;
  width: 400px;
  height: 380px;
  position: relative;
  &-number {
    position: absolute;
    right: 20px;
    top: -2px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgb(138, 170, 251);
    color: #fff;
    line-height: 24px;
    text-align: center;
  }
  &-content {
    margin: 56px 20px;
    height: calc(100% - 80px);
    &-top {
      display: flex;
      flex-wrap: wrap;
      &-item {
        display: flex;
        height: 40px;
        line-height: 40px;
        margin: 10px 5px;
        &-label {
          width: 100px;
        }
        &-num {
          width: 50px;
          text-align: center;
          font-weight: bold;
        }
      }
    }
    &-bottom {
      margin-top: 20px;
      &-item {
        display: flex;
        line-height: 24px;
        margin: 10px 5px;
        &-label {
          width: 80px;
        }
        &-val {
          // width: 50px;
          // text-align: center;
        }
      }
    }
  }
}
</style>
